module.exports = __webpack_public_path__ + "static/media/20210401_214918_664_IMG_0067.c916f724.jpg";